import { useMemo } from "react";
import { ApiHelper, ENDPOINT_SCHEMAS, APP_SOURCE } from "@cede/utils";
import { useCorrelationId } from "@/contexts/CorrelationContext";
import { clientConfig } from "@/lib/config/client-config";

const createApiHelper = (onCorrelationIdGenerated?: (id: string) => void): ApiHelper =>
  new ApiHelper(
    {
      nodeEnv: clientConfig.nodeEnv,
      apiUrl: clientConfig.apiUrl,
      apiToken: clientConfig.apiToken,
      appSource: APP_SOURCE.HUB,
      onCorrelationIdGenerated,
    },
    ENDPOINT_SCHEMAS,
  );

export function useApi(): ApiHelper {
  const { setLastCorrelationId } = useCorrelationId();
  return useMemo(() => createApiHelper(setLastCorrelationId), [setLastCorrelationId]);
}
